import { pluralize } from '@travelata-libs/utils';
import { flexCountWord, formatCheckInDayMonth } from '@/features/searchForm/dateFrom';
import { formatNightsRange, normalizeRange } from '@/features/searchForm/nightsRange';
import { totalTourists } from '@/features/searchForm/touristsRooms';
import type { DateRange } from '@/shared/model';
import { destinationSummary, type SearchFormCriteria } from '@/widgets/searchForm';
import { SERP_LAYOUT_TEXTS, TOURISTS_PLURAL_FORMS } from '../config/texts';

function formatCheckIn(dateRange: DateRange): string {
  const checkIn = formatCheckInDayMonth(dateRange);

  if (dateRange.daysFlexible <= 0) return checkIn;

  return `${checkIn} ${SERP_LAYOUT_TEXTS.flexSign}${flexCountWord(dateRange.daysFlexible)}`;
}

export function formatSearchTitle(criteria: SearchFormCriteria): string {
  const text = destinationSummary(criteria.destination, { withCountHotels: true });
  return text ? `${text}, из г. ${criteria.fromCity?.name}` : SERP_LAYOUT_TEXTS.titleFallback;
}

export function formatSearchSubtitle(criteria: SearchFormCriteria): string {
  const parts: string[] = [];

  if (criteria.dateRange) {
    parts.push(formatCheckIn(criteria.dateRange));
  }

  if (criteria.nights) {
    const { from, to } = normalizeRange(criteria.nights);
    parts.push(formatNightsRange(from, to, SERP_LAYOUT_TEXTS.nightsDash));
  }

  if (criteria.tourists) {
    parts.push(pluralize(TOURISTS_PLURAL_FORMS, totalTourists(criteria.tourists)));
  }

  return parts.filter(Boolean).join(SERP_LAYOUT_TEXTS.summaryJoin);
}
